import React, { useCallback } from 'react';
import useAuth from '../../../../../auth/UseAuth';
import { useResearchProjectId } from '../../../stores/dataStore';
import { DownloadButton } from '../../../../../components/DownloadButton';
import { appSettings } from '../../../../../AppSettings';
import { BaseDownloadFile } from '../../../../../data/BaseData';

const PatientListExportButton: React.FC = () => {
  const { accessToken } = useAuth();
  const researchProjectId = useResearchProjectId();

  const downloadData = useCallback(async () => {
    const url = `${appSettings.api.endpoint}/api/v2/PatientApproval/ResearchProject/${researchProjectId}/Patients/Export`;
    await BaseDownloadFile(url, accessToken);
  }, [accessToken, researchProjectId]);

  return (
    <DownloadButton
      id='patient-list-export-button'
      downloadData={downloadData}
      disabled={researchProjectId === undefined}
      size='small'
    />
  );
};

export default PatientListExportButton;
